import { render, staticRenderFns } from "./MediaGroupNew.vue?vue&type=template&id=24ddb592&"
import script from "./MediaGroupNew.vue?vue&type=script&lang=js&"
export * from "./MediaGroupNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports